import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Icon } from "@iconify/react";
import { Stack, Button, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { currentBoxSize,
  handleEraseToggleButton,
  handleImageToggleButton,
  handleShapeToggleButton,
  handleTextToggleButton, } from "../../../../../store/reducers/pdfeditor/toolsModificationSlice";
import { updateCoordinate } from "../../../../../store/reducers/pdfeditor/pdfCoordinatesSlice";

const BoxResizer = ({ activeTool, setActiveTool }) => {
  const [isActive, setIsActive] = useState({
    checkBox: false,
    inputBox: false,
    customBox: false,
    stampBox: true,
  });
  const [boxSize, setBoxSize] = useState({ height: 100, width: 200 });
  const { updatedBoxSize, currVariable } = useSelector(
    (state) => state.toolsModification || []
  );
  const dispatch = useDispatch();

  const handleCheckBoxSize = () => {
    setIsActive({ checkBox: true });
    setActiveTool({boxResizer : true});
    dispatch(currentBoxSize({ height: 15, width: 15 }));
    dispatch(handleTextToggleButton(false));
    dispatch(handleEraseToggleButton(false));
    dispatch(handleImageToggleButton(false));
    dispatch(handleShapeToggleButton(false));
  };
  const handleInputBoxSize = () => {
    setIsActive({ inputBox: true });
    setActiveTool({boxResizer : true});
    dispatch(currentBoxSize({ height: 15, width: 100 }));
    dispatch(handleTextToggleButton(false));
    dispatch(handleEraseToggleButton(false));
    dispatch(handleImageToggleButton(false));
    dispatch(handleShapeToggleButton(false));
  };
  const handleCustomBoxSize = () => {
    setIsActive({ customBox: true });
    setActiveTool({boxResizer : true});
    dispatch(currentBoxSize(boxSize));
    dispatch(handleTextToggleButton(false));
    dispatch(handleEraseToggleButton(false));
    dispatch(handleImageToggleButton(false));
    dispatch(handleShapeToggleButton(false));
  };

  useEffect(() => {
    dispatch(currentBoxSize(boxSize));
  }, [boxSize]);

  useEffect(() => {
    if (!updatedBoxSize) return;
    setBoxSize(updatedBoxSize);
    setIsActive({ customBox: true });
  }, [updatedBoxSize]);

  const handleChange = (e) => {
    let name = e.target.name;
    let value = Number(e.target.value);
    if (value >= 0 && !currVariable?.variable) {
      setBoxSize({ ...boxSize, [name]: value });
    } else if (value >= 0 && currVariable?.variable) {
      let data = { [name]: value };
      dispatch(
        updateCoordinate({ id: currVariable?.variable, newValue: data })
      );
      setBoxSize({ ...boxSize, [name]: value });
    }
  };
  const handleSizeSelection = (type, size) => {
    setIsActive({ stampBox: true });
    setBoxSize(size);
    setActiveTool({boxResizer : true});
    dispatch(currentBoxSize(size));
    dispatch(handleTextToggleButton(false));
    dispatch(handleEraseToggleButton(false));
    dispatch(handleImageToggleButton(false));
    dispatch(handleShapeToggleButton(false));
  };

  const MIN_HEIGHT = 50;
  const MIN_WIDTH = 100;

  // When user leaves the input
  const handleBlur = (e) => {
    let name = e.target.name;
    let value = Number(e.target.value);

    let correctedValue = value;

    if (name === "height" && value < MIN_HEIGHT) {
      correctedValue = MIN_HEIGHT;
    }
    if (name === "width" && value < MIN_WIDTH) {
      correctedValue = MIN_WIDTH;
    }

    // Update UI state
    setBoxSize((prev) => ({ ...prev, [name]: correctedValue }));

    // If variable is selected update redux coordinates
    if (currVariable?.variable) {
      dispatch(
        updateCoordinate({
          id: currVariable?.variable,
          newValue: { [name]: correctedValue },
        })
      );
    }
  };


  return (
    <Wrapper>
      <Stack direction='row' alignItems='center' spacing={1} width={"auto"}>
        {/* <Tooltip title='Checkbox' arrow>
          <Button
            onClick={handleCheckBoxSize}
            height={"20px"}
            size='sll'
            variant={activeTool.boxResizer && isActive.checkBox ? "contained" : "outlined"}
          >
            <Icon height={20} icon='memory:checkbox-marked' />
          </Button>
        </Tooltip> */}

        <Tooltip title='Box' arrow>
          <Button
            onClick={handleInputBoxSize}
            height={"20px"}
            sx={{
              textTransform: "capitalize",
              whiteSpace: "nowrap",
              fontSize: "11px",
            }}
            variant={activeTool.boxResizer && isActive.inputBox ? "contained" : "outlined"}
          >
            <Icon height={20} icon='vaadin:input' />
          </Button>
        </Tooltip>

        <Tooltip title="Stamp" arrow>
          <Button
            onClick={() => handleSizeSelection("stampBox", { height: 100, width: 200 })}
            height={"20px"}
            sx={{
              textTransform: "capitalize",
              whiteSpace: "nowrap",
              fontSize: "11px",
            }}
            variant={activeTool.boxResizer && isActive.stampBox ? "contained" : "outlined"}
          >
            <Icon height={20} icon="la:stamp" />
          </Button>
        </Tooltip>

        <Button
          onClick={handleCustomBoxSize}
          height={"20px"}
          sx={{
            textTransform: "capitalize",
            whiteSpace: "nowrap",
            fontSize: "11px",
          }}
          variant={activeTool.boxResizer && isActive.customBox ? "contained" : "outlined"}
        >
          Custom Size
        </Button>
        
        {activeTool.boxResizer && isActive.customBox && (
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <p>Height</p>
            <input
              type='number'
              value={boxSize.height}
              onChange={handleChange}
              onBlur={handleBlur}
              name='height'
              style={inputStyle}
            />
            <p>Width</p>
            <input
              type='number'
              name='width'
              value={boxSize.width}
              onBlur={handleBlur}
              onChange={handleChange}
              style={inputStyle}
            />
          </Stack>
        )}
      </Stack>
    </Wrapper>
  );
};

export default BoxResizer;
const inputStyle = {
  width: "30px",
  height: "27px",
};
const Wrapper = styled.div`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .size-display {
    display: flex;
    align-items: center;
    width: auto;
  }
  p {
    font-size: 12px;
  }
`;
